import { colorAttentionBlue50 } from "@rhumbix/rmbx_design_system_design_tokens";
import styled from "styled-components";
const LinkButton = styled.button `
    background: none !important;
    border: none;
    padding: 0 !important;
    color: ${colorAttentionBlue50};
    text-decoration: underline;
    cursor: pointer;
`;
export default LinkButton;
